import React from 'react';
import { Text } from 'react-native';
import Colors from "../../../constants/Colors";

export const KnowledgeElementTitle = ({ title }) => {
    return (
        <Text style={{ fontSize: 22, textAlign: 'center', fontWeight: 'bold', color: Colors.fontColorOnBackground, marginTop: 12, marginBottom: 12,  }}>
            { title }
        </Text>
    )
}
